export default __webpack_public_path__ + "static/media/kartax.14379e81.png";